import dayjs from "dayjs";

export function getNextLoyaltyRecalcDate(joinDate?: string) {
  if (!joinDate) {
    return {
      evaluationDate: undefined,
      daysUntilReevaluation: 30,
    };
  }
  const now = dayjs();
  let date = dayjs(joinDate);
  do {
    date = date.add(30, "days");
  } while (date.isBefore(now));

  const diff = now.diff(date, "days");

  return {
    date: date.toDate(),
    evaluationDate: joinDate && date.format("DD.MM.YYYY"),
    daysUntilReevaluation: Math.abs(diff),
  };
}
